const API_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:5000/api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('access_token');
  return {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` })
  };
};

const handleResponse = async (response) => {
  let data = await response.json();
  
  // Handle statusCode in response body (new format)
  if (data.statusCode === 401) {
    localStorage.removeItem('access_token');
    localStorage.removeItem('username');
    window.location.href = '/';
    throw new Error('Session expired');
  }
  
  // Parse body if it's a string
  if (data.body && typeof data.body === 'string') {
    data = JSON.parse(data.body);
  }
  
  return data;
};

const makeRequest = (operation, parameters) => {
  const token = localStorage.getItem('access_token');
  return fetch(API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` })
    },
    body: JSON.stringify({ body: { operation, parameters } })
  }).then(handleResponse);
};

export const api = {
  login: (username, password) => makeRequest('login', { username, password }),
  listUsers: () => makeRequest('list_users', {}),
  getUser: (username) => makeRequest('obtener_usuario', { username }),
  listProfiles: () => makeRequest('list_profiles', {}),
  getProfile: (profile_id) => makeRequest('get_profile', { profile_id }),
  createProfile: (profile) => makeRequest('create_profile', { profile }),
  updateProfile: (profile_id, profile) => makeRequest('update_profile', { profile_id, profile }),
  listAdGroups: () => makeRequest('list_ad_groups', {}),
  deleteProfile: (profile_id) => makeRequest('delete_profile', { profile_id })
};
